import tokens from '@qkindex/design-tokens';
import { Box, SxProps, Theme } from '@mui/material';

export function BrandLogo({ sx = [] }: { sx?: SxProps<Theme> }) {
  return (
    <Box
      component="span"
      role="img"
      aria-label="qkIndex"
      sx={[
        {
          display: 'block',
          fontSize: 26,
          fontWeight: tokens.font.brandWeight,
          letterSpacing: tokens.font.brandTracking,
          lineHeight: 1.2,
          color: 'text.primary',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      qkIndex
    </Box>
  );
}
